var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"delete-btn",attrs:{"depressed":"","color":"primary"},on:{"click":_vm.deleteSelected}},[_vm._v(" "+_vm._s(_vm.lang('Delete selected'))+" ("+_vm._s(_vm.selectedCount)+") ")])}
var staticRenderFns = []

export { render, staticRenderFns }